import { Grid, Box, Button } from '@mui/material';
import { TextField } from '@mui/material';
import MainCard from './MainCard';
import { gridSpacing } from '../../store/constant';
import axios from "../../components/axios";
import { useNavigate } from 'react-router-dom';
import { Controller, useForm } from "react-hook-form";


const SwallowIPForm = () => {
  const navigate = useNavigate();
  const styleButton = {
    marginTop: "40px",
    backgroundColor: "#406599",
    color: "#fff",
    borderRadius: "5px",
    boxSizing: "border-box",
    width: "100px",
    height: "45px",
    fontFamily: '"Roboto", "sans-serif"',
    fontSize: "15px",
  };

  const { handleSubmit,control } = useForm();
  const onSubmit = (data) => {
      var input_data = JSON.stringify({ agent: data.agent, ip: data.ip });

        axios.post("/peloton/v1/automation/swallow-add-setting",input_data,{withCredentials: true})
        .then(response => {
            if (response.data.message === "success") {
              navigate("/swallow-settings");
            }else{
                alert(response.data.message);
            }
        }).catch(function(err){
          if (!err.response){
            alert(err);
          }else{
            if (err.response.status === 401){
              alert(err.response.data.message);
              navigate("/");
            }else{
                console.log('error.response.status: ', err.response.status);
                console.log('error.response.status: ', err.response.data.message);
                alert(err.response.data.message);
            }
          }
        })
  };

  const onError = (errors, e) => {
    if (errors.agent !== null){
      if (errors.agent.type === 'required'){
        alert("Agent is necessary !");
      }
    }
    if (errors.ip !== null){
      if (errors.ip.type === 'required'){
        alert("IP address is necessary !");
      }
    }
  };

    return (
      <MainCard title="Add Swallow IP Setting">
        <Box sx={{ maxWidth: '100%'}}>
          <form onSubmit={handleSubmit(onSubmit, onError)}>
            <Grid container spacing={gridSpacing} justifyContent="center" rowSpacing={gridSpacing} columnSpacing={gridSpacing}>
              <Grid item xs={4}>
                <Controller
                  name="agent"
                  control={control}
                  rules={{
                    required: true
                  }}
                  defaultValue=''
                  render={({ field: { ref, ...field } }) => (
                    <TextField
                      {...field}
                      inputRef={ref}
                      fullWidth
                      id="agent"
                      label="Agent"
                      variant="filled"
                    />)}/>
              </Grid>
              <Grid item xs={4}>
                <Controller
                  name="ip"
                  control={control}
                  rules={{
                    required: true
                  }}
                  defaultValue=''
                  render={({ field: { ref, ...field } }) => (
                    <TextField
                      {...field}
                      inputRef={ref}
                      fullWidth
                      id="ip"
                      label="IP Address"
                      variant="filled"
                    />)}/>
              </Grid>
              <Grid item justifyContent="flex-end">
              <Button type="submit" style={styleButton}>Send</Button>
              </Grid>
            </Grid>
          </form>
        </Box>
      </MainCard>
    );
};

export default SwallowIPForm;
